module.exports = __webpack_public_path__ + "img/contact.1eb76d00.png";